var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNothingToShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 177,
    viewBox: "0 0 215 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.918 19.7121C11.918 10.804 19.1394 3.58258 28.0475 3.58258H140.339C149.247 3.58258 156.468 10.804 156.468 19.7121V19.7121C156.468 28.6202 149.247 35.8417 140.339 35.8417H28.0475C19.1394 35.8417 11.918 28.6202 11.918 19.7121V19.7121Z",
    fill: "url(#paint0_linear_8737_151519)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 56.2744C0.640625 47.3663 7.86207 40.1448 16.7702 40.1448H173.247C182.155 40.1448 189.376 47.3663 189.376 56.2744V56.2744C189.376 65.1825 182.155 72.4039 173.247 72.4039H16.7702C7.86207 72.4039 0.640625 65.1825 0.640625 56.2744V56.2744Z",
    fill: "url(#paint1_linear_8737_151519)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2109 92.8338C88.2109 83.9257 95.4324 76.7042 104.34 76.7042H198.79C207.698 76.7042 214.919 83.9257 214.919 92.8338V92.8338C214.919 101.742 207.698 108.963 198.79 108.963H104.34C95.4324 108.963 88.2109 101.742 88.2109 92.8338V92.8338Z",
    fill: "url(#paint2_linear_8737_151519)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4922 129.393C40.4922 120.485 47.7137 113.264 56.6218 113.264H188.835C197.743 113.264 204.965 120.485 204.965 129.393V129.393C204.965 138.301 197.743 145.523 188.835 145.523H56.6218C47.7137 145.523 40.4922 138.301 40.4922 129.393V129.393Z",
    fill: "url(#paint3_linear_8737_151519)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.345 9.1845C136.825 8.89059 138.354 8.73682 139.917 8.73682C141.48 8.73682 143.008 8.89059 144.489 9.1845C145.577 9.40059 146.285 10.4613 146.069 11.5536C145.854 12.646 144.797 13.3563 143.709 13.1402C142.484 12.897 141.216 12.7692 139.917 12.7692C138.617 12.7692 137.35 12.897 136.125 13.1402C135.037 13.3563 133.98 12.646 133.764 11.5536C133.549 10.4613 134.257 9.40059 135.345 9.1845ZM150.153 13.2537C150.77 12.3284 152.018 12.0805 152.94 12.7C155.495 14.4167 157.694 16.6241 159.405 19.1883C160.022 20.1136 159.775 21.3659 158.853 21.9854C157.931 22.6048 156.683 22.3569 156.066 21.4316C154.648 19.3053 152.823 17.4743 150.705 16.0508C149.783 15.4313 149.536 14.179 150.153 13.2537ZM129.681 13.2537C130.298 14.179 130.051 15.4313 129.129 16.0508C127.01 17.4743 125.186 19.3053 123.768 21.4316C123.151 22.3569 121.903 22.6048 120.981 21.9854C120.059 21.3659 119.812 20.1136 120.429 19.1883C122.14 16.6241 124.339 14.4167 126.894 12.7C127.816 12.0805 129.063 12.3284 129.681 13.2537ZM160.547 26.084C161.635 25.8679 162.692 26.5783 162.907 27.6706C163.2 29.1563 163.353 30.6907 163.353 32.2591C163.353 33.8274 163.2 35.3619 162.907 36.8475C162.692 37.9399 161.635 38.6502 160.547 38.4341C159.459 38.218 158.751 37.1573 158.966 36.065C159.208 34.8357 159.336 33.5633 159.336 32.2591C159.336 30.9548 159.208 29.6825 158.966 28.4532C158.751 27.3608 159.459 26.3001 160.547 26.084ZM119.287 26.084C120.375 26.3001 121.083 27.3608 120.868 28.4532C120.626 29.6825 120.498 30.9548 120.498 32.2591C120.498 33.5633 120.626 34.8357 120.868 36.065C121.083 37.1573 120.375 38.218 119.287 38.4341C118.199 38.6502 117.142 37.9399 116.927 36.8475C116.634 35.3619 116.48 33.8274 116.48 32.2591C116.48 30.6907 116.634 29.1563 116.927 27.6706C117.142 26.5783 118.199 25.8679 119.287 26.084ZM158.853 42.5328C159.775 43.1522 160.022 44.4045 159.405 45.3298C157.694 47.8941 155.495 50.1014 152.94 51.8182C152.018 52.4376 150.77 52.1897 150.153 51.2644C149.536 50.3391 149.783 49.0868 150.705 48.4674C152.823 47.0439 154.648 45.2128 156.066 43.0865C156.683 42.1612 157.931 41.9133 158.853 42.5328ZM120.981 42.5328C121.903 41.9133 123.151 42.1612 123.768 43.0865C125.186 45.2128 127.01 47.0439 129.129 48.4674C130.051 49.0868 130.298 50.3391 129.681 51.2644C129.064 52.1897 127.816 52.4376 126.894 51.8182C124.339 50.1014 122.14 47.8941 120.429 45.3298C119.812 44.4045 120.059 43.1522 120.981 42.5328ZM133.764 52.9645C133.98 51.8722 135.037 51.1618 136.125 51.3779C137.35 51.6211 138.617 51.7489 139.917 51.7489C141.216 51.7489 142.484 51.6211 143.709 51.3779C144.797 51.1618 145.854 51.8722 146.069 52.9645C146.285 54.0568 145.577 55.1175 144.489 55.3336C143.008 55.6275 141.48 55.7813 139.917 55.7813C138.354 55.7813 136.825 55.6275 135.345 55.3336C134.257 55.1175 133.549 54.0568 133.764 52.9645Z",
    fill: "#333E4D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6299 47.0711C57.6299 51.896 61.5166 55.8073 66.3111 55.8073C71.1055 55.8073 74.9922 51.896 74.9922 47.0711C74.9922 42.2462 71.1055 38.3349 66.3111 38.3349C61.5166 38.3349 57.6299 42.2462 57.6299 47.0711Z",
    fill: "#242D3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6066 35.6294C63.6066 31.6583 58.9975 29.4615 55.9194 31.9655V31.9655C52.9266 34.4001 53.9744 39.2077 57.7104 40.1833V40.1833C60.6944 40.9625 63.6066 38.7133 63.6066 35.6294V35.6294Z",
    fill: "#242D3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1863 86.4271L75.5381 116.512L66.9968 176.979L60.977 176.979L60.5359 126.921L43.7364 176.979H37.7165L49.8792 108.248L53.3968 87.0189C55.3259 75.3767 62.4201 65.4417 72.3913 59.7642L100.333 35.3787L104.297 40.0931L80.1863 86.4271Z",
    fill: "url(#paint4_linear_8737_151519)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.699 23.2379L102.856 23.2379L100.333 35.3805L104.274 40.0875C105.526 38.6233 106.336 36.8327 106.608 34.9244L107.541 28.3995L107.09 28.2182L105.558 30.4848L104.699 23.2379Z",
    fill: "#242D3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2691 128.437L34.8468 125.037L42.9155 113.071L47.6751 119.507L42.626 127.244L41.9547 126.779L42.9156 122.991L36.2691 128.437Z",
    fill: "#242D3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1289 113.945L56.5922 76.993L48.1242 119.857L41.1289 113.945Z",
    fill: "url(#paint5_linear_8737_151519)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8737_151519",
    x1: 84.1931,
    y1: 3.58258,
    x2: 84.1931,
    y2: 35.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8737_151519",
    x1: 95.0085,
    y1: 40.1448,
    x2: 95.0085,
    y2: 72.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8737_151519",
    x1: 151.565,
    y1: 76.7042,
    x2: 151.565,
    y2: 108.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8737_151519",
    x1: 122.729,
    y1: 113.264,
    x2: 122.729,
    y2: 145.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8737_151519",
    x1: 71.0067,
    y1: 35.3787,
    x2: 71.0067,
    y2: 176.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#0644B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D2858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8737_151519",
    x1: 50.3283,
    y1: 76.7029,
    x2: 50.3283,
    y2: 120.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003699"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingToShow);
export default __webpack_public_path__ + "static/media/nothing-to-show.7131e9f97b05b98412bfb2b832fb3b71.svg";
export { ForwardRef as ReactComponent };